import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download/698336b5921dc900147b5edb/acuilcreations/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698336b5921dc900147b5edb/acuilcreations/src/app/admin/components/AdminDashboard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698336b5921dc900147b5edb/acuilcreations/src/components/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/698336b5921dc900147b5edb/acuilcreations/src/components/ui/AppIcon.tsx");
